import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm, ValidatedBlobField, ValidatedInput } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IBlog } from 'app/shared/model/blog.model';
import { getEntity, updateEntity, createEntity, reset } from './blog.reducer';

export const BlogUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const blogEntity = useAppSelector(state => state.blog.entity);
  const loading = useAppSelector(state => state.blog.loading);
  const updating = useAppSelector(state => state.blog.updating);
  const updateSuccess = useAppSelector(state => state.blog.updateSuccess);

  const handleClose = () => {
    navigate('/blog' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...blogEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...blogEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="fitengineerBackendV2App.blog.home.createOrEditLabel" data-cy="BlogCreateUpdateHeading">
            <Translate contentKey="fitengineerBackendV2App.blog.home.createOrEditLabel">Create or edit a Blog</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="blog-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('fitengineerBackendV2App.blog.blogTitle')}
                id="blog-blogTitle"
                name="blogTitle"
                data-cy="blogTitle"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <ValidatedInput
                label={translate('fitengineerBackendV2App.blog.blogContent')}
                id="blog-blogContent"
                name="blogContent"
                data-cy="blogContent"
                type="textarea"
                col={15}
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
                style={{ height: '200px', resize: 'vertical' }}
              />
              <ValidatedBlobField
                label={translate('fitengineerBackendV2App.blog.image1')}
                id="blog-image1"
                name="image1"
                data-cy="image1"
                isImage
                accept="image/*"
              />
              <ValidatedBlobField
                label={translate('fitengineerBackendV2App.blog.image2')}
                id="blog-image2"
                name="image2"
                data-cy="image2"
                isImage
                accept="image/*"
              />
              <ValidatedBlobField
                label={translate('fitengineerBackendV2App.blog.image3')}
                id="blog-image3"
                name="image3"
                data-cy="image3"
                isImage
                accept="image/*"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/blog" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BlogUpdate;
